export const PermissionKey_DeveloperViewer = 'permission-key--developer-viewer';
export const PermissionKey_DeveloperWriter = 'permission-key--developer-editor';
export const PermissionKey_DeveloperAdmin = 'permission-key--developer-admin';
export const PermissionKey_AccountManagementAdmin = 'permission-key--account-management-admin';
//# sourceMappingURL=permission-keys.js.map